function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_588_3679",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_588_3679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.2178C9.8996 12.2178 9.80612 12.2018 9.71959 12.1697C9.63305 12.1377 9.55078 12.0826 9.4728 12.0047L5.72761 8.25946C5.61222 8.14409 5.55105 8.0012 5.54411 7.8308C5.53717 7.66039 5.59833 7.51055 5.72761 7.38128C5.84833 7.26055 5.99469 7.20019 6.16669 7.20019C6.33869 7.20019 6.48505 7.26055 6.60578 7.38128L10 10.7627L13.3943 7.38128C13.5097 7.2659 13.6525 7.20474 13.8229 7.1978C13.9933 7.19085 14.1432 7.25201 14.2724 7.38128C14.3932 7.502 14.4535 7.64837 14.4535 7.82038C14.4535 7.99238 14.3932 8.13874 14.2724 8.25946L10.5273 12.0047C10.4493 12.0826 10.367 12.1377 10.2805 12.1697C10.1939 12.2018 10.1005 12.2178 10 12.2178Z",
    fill: "#19346F",
    style: {
      fill: "#19346F",
      fill: "color(display-p3 0.0980 0.2039 0.4353)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.47a4f3f9a090a4cc42181971db37d35b.svg";
export { ForwardRef as ReactComponent };